import React from "react";
import { connect } from "react-redux";
import withStyles from "@material-ui/core/styles/withStyles";
import { MuiThemeProvider, createMuiTheme } from "@material-ui/core/styles";
import extendedTablesStyle from "../../assets/jss/material-dashboard-pro-react/views/extendedTablesStyle.jsx";
import ReactTable from "react-table";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import moment from "moment";
import { Select, MenuItem, InputLabel } from "@material-ui/core";
// Icons
//core components
import TextField from "@material-ui/core/TextField";
// import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "../../components/Grid/GridItem.jsx";
import Card from "../../components/Card/Card.jsx";
// import CardBody from "components/Card/CardBody.jsx";
// import CardIcon from "components/Card/CardIcon.jsx";
// import CardHeader from "components/Card/CardHeader.jsx";
// import Avatar from "@material-ui/core/Avatar";
// import IconButton from "@material-ui/core/IconButton";
// import Icon from "@material-ui/core/Icon";
// import Tooltip from "@material-ui/core/Tooltip";
// import Switch from "@material-ui/core/Switch";
// import green from "@material-ui/core/colors/green";
// import DeleteModel from "../../components/Common/FevoModels/DeleteModel";
import { getCustomerData } from "../../actions/customerActions";
import toastr from "toastr";
import axios from "axios";
import { domain } from "../../utils/util";
import { Button, CardContent } from "@material-ui/core";
import { Form } from "react-bootstrap";
// let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
// let config = {};
// if (data) {
//   config = {
//     headers: { Authorization: `Bearer ${data.token}` },
//   };
// }
class ManageCustomers extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      berpay_transaction_fee: {
        in_percent: null,
        fixed_per_person: null,
      },
      wallet_transfer_transaction_fee: {
        in_percent: null,
        fixed_value: null,
      },
      circle_transaction_fee: {
        in_percent: null,
        fixed_value: null,
      },
      key_name: "berpay_transaction_fee",
      key_value1: "",
      key_value2: "",
      key_value: "",
      afterdecimal: "",
      count: 0,
      isEdit: false,
    };
  }

  componentDidMount = () => {
    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }

    axios
      .get(`${domain}/setting/transaction/fee`, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          this.setState({
            ...this.state.berpay_transaction_fee,
            berpay_transaction_fee: res.data.data[0].berpay_transaction_fee,
            wallet_transfer_transaction_fee:
              res.data.data[0].wallet_transfer_transaction_fee,
            circle_transaction_fee: res.data.data[0].circle_transaction_fee,
          });
        } else {
          toastr.error(res.data.message);
        }
      })

      .catch((error) => {
        console.error(error);
      });
  };

  submitForm = (e) => {
    e.preventDefault();

    let data = JSON.parse(localStorage.getItem("BerPay_Admin"));
    let config = {};
    if (data) {
      config = {
        headers: { Authorization: `Bearer ${data.token}` },
      };
    }
    let body = {
      purpose: "transaction_fee",
      circle_transaction_fee: this.state.circle_transaction_fee,
      wallet_transfer_transaction_fee: this.state
        .wallet_transfer_transaction_fee,
      berpay_transaction_fee: this.state.berpay_transaction_fee,
      // "key_name":this.state.key_name,
      // "key_value": this.state.key_name==="TransactionFee" ? this.state.key_value1 : this.state.key_value2,
    };
    axios
      .put(`${domain}/setting/add/transaction/fee`, body, config)
      .then((res) => {
        if (res.data.statusCode === 200 || res.data.statusCode === 201) {
          toastr.success("Transaction Updated Successfully!");
          setTimeout(() => {
            window.location.reload();
          }, 3000);

          // this.props.history.goBack();
        } else {
          toastr.error("Please enter valid transaction fee");
        }
      })
      .catch((error) => {});
  };

  handleChange = (event) => {
    console.log(event);
    if (
      event.target.name == "percent" &&
      event.target.value.indexOf(".") !== -1
    ) {
      let divided = event.target.value.split(".");
      if (divided[1].length > 2) {
        toastr.error("Only 2 digits are allowed after decimal!");
      } else {
        if (this.state.key_name === "berpay_transaction_fee") {
          this.setState({
            ...this.state,
            berpay_transaction_fee: {
              ...this.state.berpay_transaction_fee,
              in_percent: event.target.value,
            },
          });
        } else if (this.state.key_name === "wallet_transfer_transaction_fee") {
          this.setState({
            ...this.state,
            wallet_transfer_transaction_fee: {
              ...this.state.wallet_transfer_transaction_fee,
              in_percent: event.target.value,
            },
          });
        } else {
          this.setState({
            ...this.state,
            circle_transaction_fee: {
              ...this.state.circle_transaction_fee,
              in_percent: event.target.value,
            },
          });
        }
        // this.setState({isEdit:true})
      }
    } else if (
      event.target.name == "fixed" &&
      event.target.value.indexOf(".") !== -1
    ) {
      let divided = event.target.value.split(".");
      if (divided[1].length > 2) {
        toastr.error("Only 2 digits are allowed after decimal!");
      } else {
        {
          if (this.state.key_name === "berpay_transaction_fee") {
            this.setState({
              ...this.state,
              berpay_transaction_fee: {
                ...this.state.berpay_transaction_fee,
                fixed_per_person: event.target.value,
              },
            });
          } else if (
            this.state.key_name === "wallet_transfer_transaction_fee"
          ) {
            this.setState({
              ...this.state,
              wallet_transfer_transaction_fee: {
                ...this.state.wallet_transfer_transaction_fee,
                fixed_value: event.target.value,
              },
            });
          } else {
            this.setState({
              ...this.state,
              circle_transaction_fee: {
                ...this.state.circle_transaction_fee,
                fixed_value: event.target.value,
              },
            });
          }
          // this.setState({isEdit:true})
        }
      }
    } else {
      console.log("22", event.target.name);
      if (event.target.name === "percent") {
        console.log("percent");
        if (this.state.key_name === "berpay_transaction_fee") {
          this.setState({
            ...this.state,
            berpay_transaction_fee: {
              ...this.state.berpay_transaction_fee,
              in_percent: event.target.value,
            },
          });
        } else if (this.state.key_name === "wallet_transfer_transaction_fee") {
          this.setState({
            ...this.state,
            wallet_transfer_transaction_fee: {
              ...this.state.wallet_transfer_transaction_fee,
              in_percent: event.target.value,
            },
          });
        } else {
          this.setState({
            ...this.state,
            circle_transaction_fee: {
              ...this.state.circle_transaction_fee,
              in_percent: event.target.value,
            },
          });
        }
      } else if (event.target.name === "fixed") {
        console.log("fixed");
        if (this.state.key_name === "berpay_transaction_fee") {
          this.setState({
            ...this.state,
            berpay_transaction_fee: {
              ...this.state.berpay_transaction_fee,
              fixed_per_person: event.target.value,
            },
          });
        } else if (this.state.key_name === "wallet_transfer_transaction_fee") {
          this.setState({
            ...this.state,
            wallet_transfer_transaction_fee: {
              ...this.state.wallet_transfer_transaction_fee,
              fixed_value: event.target.value,
            },
          });
        } else {
          this.setState({
            ...this.state,
            circle_transaction_fee: {
              ...this.state.circle_transaction_fee,
              fixed_value: event.target.value,
            },
          });
        }
      } else {
        console.log("33");
        this.setState({
          key_name: event.target.value,
        });
      }
      // this.setState({isEdit:true})
    }
  };

  render() {
    const { classes } = this.props;
    const {
      isEdit,
      key_name,
      key_value1,
      key_value2,
      key_value,
      berpay_transaction_fee,
      wallet_transfer_transaction_fee,
      circle_transaction_fee,
    } = this.state;
    const fixed =
      key_name === "circle_transaction_fee"
        ? circle_transaction_fee.fixed_value
        : key_name === "berpay_transaction_fee"
        ? berpay_transaction_fee.fixed_per_person
        : wallet_transfer_transaction_fee.fixed_value;
    const percent =
      key_name === "circle_transaction_fee"
        ? circle_transaction_fee.in_percent
        : key_name == "berpay_transaction_fee"
        ? berpay_transaction_fee.in_percent
        : wallet_transfer_transaction_fee.in_percent;

    console.log("()+++++++++", fixed);
    // if(fixed && fixed.toString().indexOf(".")!==-1)
    // {
    //   let value_1=fixed.toString().split(".")[1]
    //   if(value_1 && value_1.length<2)
    //   {
    //     let
    //   }
    // }
    return (
      <div>
        <Card>
          <CardContent>
            <Form onSubmit={this.submitForm}>
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="key_name"
                  id="key_name"
                  label="Key Name"
                  type="text"
                  disabled={isEdit}
                  onChange={this.handleChange}
                  fullWidth
                  value={key_name}
                  style={{ marginBottom: "20px" }}
                  select
                >
                  <MenuItem value="circle_transaction_fee">
                    {"Circle Transaction Fee"}
                  </MenuItem>
                  <MenuItem value="berpay_transaction_fee">
                    {"BerPay Transaction Fee"}
                  </MenuItem>
                  <MenuItem value="wallet_transfer_transaction_fee">
                    {"Wallet Transfer Transaction Fee"}
                  </MenuItem>
                </TextField>
              </GridItem>
              {/* { key_name==="circle_transaction_fee" ?  */}
              <GridItem xs={12}>
                <TextField
                  autoFocus
                  margin="dense"
                  name="fixed"
                  id="fixed"
                  label="Fixed Fee"
                  type="text"
                  disabled={isEdit}
                  onChange={this.handleChange}
                  fullWidth
                  value={fixed === null ? "" : fixed}
                  style={{ marginBottom: "20px" }}
                />
                <TextField
                  autoFocus
                  margin="dense"
                  name="percent"
                  id="percent"
                  label="Percent ( % )"
                  type="text"
                  onChange={this.handleChange}
                  fullWidth
                  value={percent === null ? " " : percent}
                  style={{ marginBottom: "20px" }}
                />
              </GridItem>

              <GridItem xs={12} className="new_Card">
                {/* { isEdit? */}
                <Button variant="contained" color="primary" type="submit">
                  Submit
                </Button>
              </GridItem>
            </Form>
          </CardContent>
        </Card>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    // users: state.products.categories
  };
};

const mapDispatchToProps = (dispatch) => {
  return {
    getCustomerData: () => dispatch(getCustomerData()),
    // fetchCategories: ()=> dispatch(fetchCategories()),
    // categoryFormContent: (obj) => {dispatch({ type: PRODUCT_CATEGORY_ACTION.OPEN_CATEGORY_FORM, payload: obj })},
    // editCategory: (obj) => dispatch(editCategory(obj)),
    // deleteCategory: (obj,callback) => dispatch(deleteCategory(obj,callback)),
  };
};

const ManageCustumersComponent = withStyles(extendedTablesStyle)(
  ManageCustomers
);
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ManageCustumersComponent);
